import { getCookie, deleteCookie } from "../../helper";
import { Login, Signup } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { setUserFromShopify, selectLogInUsername, selectRealSessionEmail, setLogInUser, graphStatus, fetchUserAccountInfo, fetchUserRole, selectUserRole, fetchClientName, selectClientName, resetAuthSlice } from "./authSlice";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { checkAgentEnabled } from "../../layout/AIAgent/agentSlice";

export default function AuthenticateDashboard(component) {

    return function AuthenticateDashboard(props) {
        const dispatch = useDispatch();
        const location = useLocation();
        const sessionUser = useSelector(selectRealSessionEmail);
        const userRole = useSelector(selectUserRole);
        const resolvedClientName = useSelector(selectClientName);
        const referer = document.referrer ? document.referrer : '';

        // 1. Fetch clientName when sessionUser is set
        useEffect(() => {
            if (!sessionUser) return;
            dispatch(fetchClientName(sessionUser));
        }, [sessionUser, dispatch]);

        // 2. Fetch data once clientName is resolved
        useEffect(() => {
            if (!resolvedClientName || !sessionUser) return;
            dispatch(graphStatus(resolvedClientName));
            dispatch(fetchUserAccountInfo(resolvedClientName));
            dispatch(checkAgentEnabled(resolvedClientName));
            // Fetch role every time user is resolved
            dispatch(fetchUserRole({ clientName: resolvedClientName, email: sessionUser }));
        }, [resolvedClientName, sessionUser, dispatch]);
        // 3. Handle 'denied' access
        useEffect(() => {
            if (userRole === 'denied') {
                deleteCookie('user');
                signOut(auth).catch(console.error);
                dispatch(resetAuthSlice());
            }
        }, [userRole, dispatch]);
        
        if (referer.includes('shopify')) {
            if (sessionUser) {
                // Still loading role or client name
                if (userRole === null || resolvedClientName === null) return null;
                // Denied
                if (userRole === 'denied') {
                    return <Login />;
                }
                return component(props);
            }
            else {
                dispatch(setUserFromShopify(referer));
                if (location.pathname.includes('start-free-trial')) return <Signup />;
                return <Login />;
            }
        } else if (!sessionUser) {
            const user = getCookie('user');
            if (user) {
                console.log("----user from cookies----", user);
                dispatch(setLogInUser(user));
                // Wait for role to be resolved before rendering the dashboard
                return null;
            }
            if (location.pathname.includes('start-free-trial')) return <Signup />;
            return <Login />;
        } else if (sessionUser) {
            // Still loading role or client name — don't flash the dashboard
            if (userRole === null || resolvedClientName === null) return null;
            // Access denied — clear cookie, redux state, and firebase session so revoked users can't loop back in
            if (userRole === 'denied') {
                return <Login />;
            }
            return component(props);
        }
    }
}